module.exports = __webpack_public_path__ + "static/img/bigbanner01.6cbfa883.png";